export default __webpack_public_path__ + "3ce8858e9723be3b3c32b0333d692e0a.svg";